/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Not_SetInputs */

const en_profile_not_set = /** @type {(inputs: Profile_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not set`)
};

const es_profile_not_set = /** @type {(inputs: Profile_Not_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No establecido`)
};

/**
* | output |
* | --- |
* | "Not set" |
*
* @param {Profile_Not_SetInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_not_set = /** @type {((inputs?: Profile_Not_SetInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Not_SetInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_not_set(inputs)
	return en_profile_not_set(inputs)
});